import { APIInstance } from 'config/configApi';
import { API } from 'constants/apiEndpoints';
import { RESPONSE_TYPE, USER_PROFILE } from 'models';
import {
  NOTIFY_SETTING_PAYLOAD,
  PARENT_CHANGE_PASSWORD_REQUEST,
  PARENT_UPDATE_PROFILE_REQUEST,
} from 'models/profile';

export const profileApi = {
  getProfile: () => {
    return APIInstance.get<RESPONSE_TYPE<USER_PROFILE>>(API.PROFILE.DEFAULT);
  },
  updateProfile: (data: PARENT_UPDATE_PROFILE_REQUEST) => {
    return APIInstance.put<RESPONSE_TYPE<any>>(API.PROFILE.EDIT, data);
  },
  changePassword: (data: PARENT_CHANGE_PASSWORD_REQUEST) => {
    return APIInstance.put<RESPONSE_TYPE<any>>(
      API.PROFILE.CHANGE_PASSWORD,
      data,
    );
  },
  notifySetting: (parentId: string, data: NOTIFY_SETTING_PAYLOAD) => {
    return APIInstance.put<RESPONSE_TYPE<any>>(
      API.PROFILE.NOTIFY_SETTING(parentId),
      data,
    );
  },
};
